<template>
  <div class="container-custom" :style="styleObject">
    <div class="content-custom" v-on:scroll.passive='handleScroll($event)'>
      <!-- M1045: slim bar that takes over search / table / language once the
           banner (which carries them at the top) has scrolled away. The
           zero-height sticky anchor keeps it from pushing the page down. -->
      <div v-if="isLoadDone" class="moo-compact-anchor">
        <div class="moo-compact" :class="{ 'is-shown': isHeaderCompact || isCompactSearchFocus }">
          <div class="moo-search">
            <i class="material-icons-round moo-search__icon" aria-hidden="true">search</i>
            <input
              class="moo-search__input"
              type="text"
              inputmode="search"
              :value="searchKeyword"
              :placeholder="$t('order.searchPlaceholder')"
              aria-label="Search items"
              @input="onChangesearchKeyword($event.target.value)"
              @focus="isCompactSearchFocus = true"
              @blur="isCompactSearchFocus = false"
            />
          </div>
          <div v-if="tableInfo && tableInfo.table_no" class="moo-table-pill">
            <span class="moo-table-pill__label">{{ $t('order.table') }}</span>
            <span class="moo-table-pill__no">{{ tableInfo.table_no }}</span>
          </div>
          <OrderTopBar variant="compact" @lang="syncMenuNames" />
        </div>
      </div>
      <div class="order-info" :class="{ 'grid': typeList == 2 }">
        <div class="content" v-if="isLoadDone">
          <div v-if="flyState" class="fly-item" :style="flyStyle" aria-hidden="true"></div>
          <div>
            <!-- M1045: logo, language, search and table sit on the banner
                 instead of stacking above it. -->
            <div class="moo-hero" ref="hero">
            <div class="banner" v-if="slidesHomePage && slidesHomePage.length > 1">
              <swiper
                :slides-per-view="1"
                :space-between="0"
                :loop="true"
                :autoplay="{
                  delay: 3000,
                  disableOnInteraction: false,
                }"
                :initialSlide="0"
              >
                <swiper-slide v-for="(value, index) in slidesHomePage" :key="index">
                  <div class="slider">
                    <img
                      :src=value.file_url
                      alt="error"
                    />
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="banner" v-else-if="slidesHomePage && slidesHomePage.length">
              <swiper
                :slides-per-view="1"
                :space-between="0"
                :autoplay="{
                  delay: 3000,
                  disableOnInteraction: false,
                }"
              >
                <swiper-slide v-for="(value, index) in slidesHomePage" :key="index">
                  <div class="slider">
                    <img
                      :src=value.file_url
                      alt="error"
                    />
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <!-- No banner uploaded: a theme-colour band carries the header. -->
            <div v-else class="moo-hero__band"></div>
            <div class="moo-hero__overlay">
              <OrderTopBar variant="overlay" @lang="syncMenuNames" />
              <section class="moo-search-row">
                <div class="moo-search">
                  <i class="material-icons-round moo-search__icon" aria-hidden="true">search</i>
                  <input
                    class="moo-search__input"
                    type="text"
                    inputmode="search"
                    :value="searchKeyword"
                    :placeholder="$t('order.searchPlaceholder')"
                    aria-label="Search items"
                    @input="onChangesearchKeyword($event.target.value)"
                  />
                </div>
                <div v-if="tableInfo && tableInfo.table_no" class="moo-table-pill">
                  <span class="moo-table-pill__label">{{ $t('order.table') }}</span>
                  <span class="moo-table-pill__no">{{ tableInfo.table_no }}</span>
                </div>
              </section>
            </div>
            </div>
            <div class="category-info" :class="{ 'list': typeList == 1 }">
              <!-- <div class="category-list" v-if="typeList == 2">
                <div
                  v-for="(category, index) in categories"
                  :key="index"
                  class="category-tag"
                  :id="'category-tag-' + category.id"
                  :class="[{ 'active': categorySelect.id == category.id }, 'tag-name-category-' + category.id]"
                  @click="selectCategory(category, index)"
                >
                  <div class="wrap-category">
                    <img :src="category.img_version" alt="error" />
                    <img v-if="category.is_feature"
                      class="custom-star"
                      src="@/assets/img/star.png"
                      alt="logo"
                    />
                  </div>
                  <div>{{ tName(category.second_name) }}</div>
                </div>
              </div> -->
              <div class="cat-layout">
                <CategorySidebar
                  class="cat-layout__side"
                  :style="{ '--cat-top': '60px', '--cat-height': 'calc(100vh - 60px)' }"
                  :categories="categories"
                  :active-index="categoryIndexSelect"
                  @select="onSidebarSelect"
                />
                <div class="cat-layout__main">
              <!-- Search results: keep the banner + category sidebar mounted and
                   swap only this main column (matches advocado's search UX). -->
              <div v-if="isSearch" class="category-detail" :class="{ 'list': typeList == 1 }">
                <div class="item-list">
                  <div class="moo-search-head">
                    <div class="d-flex align-items-center justify-content-between moo-cathead-row">
                      <div class="d-flex align-items-center">{{ $t('order.searchResults') }}</div>
                      <span class="moo-cat-count">{{ itemSearch.length }} Items</span>
                    </div>
                  </div>
                  <div v-if="itemSearch.length" class="list m-0">
                <div
                  class="item-tag"
                  v-for="(item, index) in itemSearch"
                  :key="index"
                  @click="gotoOrderDetail(item.category_id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                  :style="{ background: checkAndReturnSignature(item.tags) !== '' ? 'var(--moo-signature-bg, #FFF8E4)' : '', position: 'relative' }"
                  :class="{ 'selectedItem': getTotalQuantityById(item.id) > 0 }" 
                  style="position: relative"
                >
                  <div :style="{ position: 'relative', opacity: !checkAvailableItem(item) ? 0.5 : 1 }">
                    <div class="item-img" :class="'item-img-' + item.category_id + '-' + item.id">
                      <img :src="item.image" width="100" height="100" alt="error" style="border-radius: 5px;" />
                    </div>
                    <div class="item-info ms-2 w-100" style="height: 100%;">
                      <div style="line-height: normal;font-weight: unset;margin-top: -3px;font-size: 15px;">{{ tName(item.item_name) }}</div>
                      <div style="margin-top: 5px;">{{ subLine(item) }}</div>
                      <div class="mt-1">
                        <div v-if="item.member_price != item.price_default">
                          <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                          <div class="member-price" :class="{ 'active': isLogined }">
                            <span v-if="isLogined" class="font-weight-normal fs-11">
                              {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                            </span>
                            <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                          </div>
                        </div>
                        <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                        <div style="display: flex;gap: 10px;">
                          <div class="txt_popular" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                          <div class="txt_popular" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                        </div>
                      </div>
                      <div v-if="!checkAvailableItem(item)" style="color: white;font-size: 14px;width: 100%;">{{ $t('order.notAvailable') }}</div>
                    </div>
                    <div class="change-item-qty">
                      <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || item.quantityNew) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                          <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                            <div @click.stop="openBoxChangeQuantityForItemWithoutModifierWhenSearch(index, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                              <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || item.quantityNew) }}</span>
                            </div>
                          </div>
                      </div>
                      <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                          <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                            <div @click.stop="handleQuantityForMainItemWhenSearch(item, 1, index, item.category_id)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                              <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                            </div>
                            <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                              <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                            </div>
                            <div @click.stop="handleQuantityForMainItemWhenSearch(item, 2, index, item.category_id)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                              <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                            </div>
                          </div>
                      </div>
                      <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || item.quantityNew) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                          <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                            <div @click.stop="handleQuantityForMainItemWhenSearch(item, 1, index, item.category_id)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                              <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                            </div>
                            <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                              <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || item.quantityNew) }}</span>
                            </div>
                            <div @click.stop="handleQuantityForMainItemWhenSearch(item, 2, index, item.category_id)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                              <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                            </div>
                          </div>
                      </div>
                      <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(item.category_id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;position: absolute;right: 0;bottom: 10px;align-items: center;justify-content: center;display: flex;">
                        <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                      </div>
                      <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click.stop="openBoxChangeQuantityForItemWithoutModifierWhenSearch(index, item, item.category_id)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                        <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                      </div>
                      <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(item.category_id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                        <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                      </div>
                    </div>
                  </div>
                </div>
                  </div>
                  <div v-else class="moo-search-empty">No items match "{{ searchKeyword }}".</div>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center group-and-type-list" :class="{ 'list': typeList == 1 }" v-if="!isSearch">
                <div
                  class="group-list me-2"
                  v-if="
                    categorySelect &&
                    categorySelect.groups
                  "
                >
                  <div
                    v-for="(group, index) in categorySelect.groups"
                    :key="index"
                    class="group-tag"
                    :id="'group-tag-' + group.id"
                    @click="selectGroup(group)"
                  >
                    {{ tName(group.name) }}
                  </div>
                </div>
              </div>
              <div class="category-detail" :class="{ 'list': typeList == 1 }" v-if="!isSearch && categories.length">
                <menu-banner
                  v-if="upsellBanners.length"
                  :banners="upsellBanners"
                  @tap="onUpsellBannerTap"
                />
                <div class="item-list" v-for="(category, index) in categories" :key="index">
                  <div>
                    <div class="tag-name-category" :id="'tag-name-category-' + category.id" style="align-items: center;">
                      <div class="d-flex align-items-center justify-content-between moo-cathead-row">
                        <div class="d-flex align-items-center">
                          {{ tName(category.second_name) }}
                          <img v-if="category.is_feature"
                            class="ms-2 me-3 mb-0"
                            style="width: 20px"
                            src="@/assets/img/star.png"
                            alt="logo"
                          />
                        </div>
                        <span class="moo-cat-count" v-if="category.items && category.items.length">{{ $t('order.itemCount', { count: category.items.length }) }}</span>
                      </div>
                      <div class="category-description" v-if="category.details">
                        {{ category.details }}
                      </div>
                    </div>
                    <div class="list border-0 mt-1" v-if="typeList == 1">
                      <div
                        class="item-tag"
                        v-for="(item, index2) in category.items"
                        :key="index2"
                        :class="{ 'selectedItem': getTotalQuantityById(item.id) > 0 }" 
                        style="position: relative;"
                      >
                        <div :style="{ position: 'relative', opacity: !checkAvailableItem(item) ? 0.5 : 1 }" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)">
                          <div class="item-img" :class="'item-img-' + category.id + '-' + item.id">
                            <img :src="item.image" width="100" height="100" alt="error" style="border-radius: 5px;" />
                          </div>
                          <div class="item-info ms-2 w-100" style="height: 100%;">
                            <div style="line-height: normal;font-weight: unset;margin-top: -3px;font-size: 15px;">{{ tName(item.item_name) }}</div>
                            <div style="margin-top: 5px;">{{ subLine(item) }}</div>
                            <div class="mt-1">
                              <div v-if="item.member_price != item.price_default">
                                <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                <div class="member-price" :class="{ 'active': isLogined }">
                                  <span v-if="isLogined" class="font-weight-normal fs-11">
                                    {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                                  </span>
                                  <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                                </div>
                              </div>
                              <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                              <div style="display: flex;gap: 10px;">
                                <div class="txt_popular" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                                <div class="txt_popular" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                              </div>
                            </div>
                            <div v-if="!checkAvailableItem(item)" style="color: var(--moo-error, #eb2f06);font-size: 14px;width: 100%;">{{ $t('order.notAvailable') }}</div>
                          </div>
                        </div>
                        <div class="change-item-qty">
                          <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                              <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                <div @click.stop="openBoxChangeQuantityForItemWithoutModifier(index, index2, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                  <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                </div>
                              </div>
                          </div>
                          <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                              <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                <div @click.stop="handleQuantityForMainItem(item, 1, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                  <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                </div>
                                <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                  <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                                </div>
                                <div @click.stop="handleQuantityForMainItem(item, 2, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                  <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                </div>
                              </div>
                          </div>
                          <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                              <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                <div @click.stop="handleQuantityForMainItem(item, 1, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                  <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                </div>
                                <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                  <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                </div>
                                <div @click.stop="handleQuantityForMainItem(item, 2, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                  <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                </div>
                              </div>
                          </div>
                          <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;position: absolute;right: 0;bottom: 10px;align-items: center;justify-content: center;display: flex;">
                            <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                          </div>
                          <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click.stop="openBoxChangeQuantityForItemWithoutModifier(index, index2, item, category.id)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                            <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                          </div>
                          <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                            <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid border-0" v-else>
                      <div class="row ms-0 me-0 row-flex">
                        <div
                          class="col-6"
                          :class="{ 'ps-0': index2 % 2 == 0, 'pe-0': index2 % 2 == 1 }"
                          v-for="(item, index2) in category.items"
                          :key="index2"
                          @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                          
                        >
                          <div class="col-12 text-center item-info h-100" :class="['item-img-' + category.id + '-' + item.id, {'item-not-available': !checkAvailableItem(item) }]" style="position: relative">
                            <img
                            :src="item.image"
                              alt="error"
                              style="width:100%;"
                            />
                            <div class="mt-2" style="line-height: normal;font-weight: unset;font-size: 15px;">{{ tName(item.item_name) }}</div>
                            <div style="display: flex;gap: 3px;margin-top: 5px;margin-bottom: 5px;align-items: center;justify-content: center;">
                              <div class="txt_popular_grid" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                              <div class="txt_popular_grid" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                            </div>
                            <div v-if="item.member_price != item.price_default">
                              <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                              <div class="member-price" :class="{ 'active': isLogined }">
                                <span v-if="isLogined" class="font-weight-normal fs-11">
                                  {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                                </span>
                                <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                              </div>
                            </div>
                            <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                            <div v-if="!checkAvailableItem(item)" style="color: var(--moo-error, #eb2f06);font-size: 14px;">{{ $t('order.notAvailable') }}</div>
                            <div class="change-item-qty add-more-item">
                              <div class="d-flex justify-content-center">
                                <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                  <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                    <div @click.stop="openBoxChangeQuantityForItemWithoutModifier(index, index2, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                  <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                    <div @click.stop="handleQuantityForMainItem(item, 1, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                    </div>
                                    <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                                    </div>
                                    <div @click.stop="handleQuantityForMainItem(item, 2, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                    </div>
                                  </div>
                                </div>
                                <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                  <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                    <div @click.stop="handleQuantityForMainItem(item, 1, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                    </div>
                                    <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                    </div>
                                    <div @click.stop="handleQuantityForMainItem(item, 2, category.id, index, index2)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                    </div>
                                  </div>
                                </div>
                                <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;align-items: center;justify-content: center;">
                                  <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                                </div>
                                <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click.stop="openBoxChangeQuantityForItemWithoutModifier(index, index2, item, category.id)" style="width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                  <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+<a href="http://" target="_blank" rel="noopener noreferrer"></a></span>
                                </div>
                                <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                  <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="category.groups && category.groups.length">
                    <div class="item-list" v-for="(group, index3) in category.groups" :key="index3">
                      <div>
                        <div class="tag-name-group" :class="'tag-name-group-' + group.id">
                          {{ tName(group.name) }}
                        </div>
                        <div class="list border-0" v-if="typeList == 1">
                          <div
                            class="item-tag"
                            v-for="(item, index4) in group.items"
                            :key="index4"
                            @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                            :class="{ 'selectedItem': getTotalQuantityById(item.id) > 0 }"
                            style="position: relative;"
                          >
                            <div :style="{ position: 'relative', opacity: !checkAvailableItem(item) ? 0.5 : 1 }">
                              <div class="item-img" :class="'item-img-' + category.id + '-' + group.id + '-' + item.id">
                                <img :src="item.image" width="100" height="100" alt="error" style="border-radius: 5px;" />
                              </div>
                              <div class="item-info ms-2 w-100" style="height: 100%;">
                                <div style="line-height: normal;font-weight: unset;margin-top: -3px;font-size: 15px;">{{ tName(item.item_name) }}</div>
                                <div style="margin-top: 5px;">{{ subLine(item) }}</div>
                                <div class="mt-1">
                                  <div v-if="item.member_price != item.price_default">
                                    <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                    <div class="member-price" :class="{ 'active': isLogined }">
                                      <span v-if="isLogined" class="font-weight-normal fs-11">
                                        {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                                      </span>
                                      <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                                    </div>
                                  </div>
                                  <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                  <div style="display: flex;gap: 10px;">
                                    <div class="txt_popular" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                                    <div class="txt_popular" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                                  </div>
                                </div>
                                <div v-if="!checkAvailableItem(item)" style="color: var(--moo-error, #eb2f06);font-size: 14px;width: 100%;">{{ $t('order.notAvailable') }}</div>
                              </div>
                            </div>
                            <div class="change-item-qty">
                              <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || group.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                                  <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                    <div @click.stop="groupOpenBoxChangeQuantityForItemWithoutModifier(index3, index4, index, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || group.quantity) }}</span>
                                    </div>
                                  </div>
                              </div>
                              <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                                  <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                    <div @click.stop="groupHandleQuantityForMainItem(item, 1, category.id, index3, index4, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                    </div>
                                    <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                                    </div>
                                    <div @click.stop="groupHandleQuantityForMainItem(item, 2, category.id, index3, index4, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                    </div>
                                  </div>
                              </div>
                              <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || group.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                                  <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                    <div @click.stop="groupHandleQuantityForMainItem(item, 1, category.id, index3, index4, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                    </div>
                                    <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || group.quantity) }}</span>
                                    </div>
                                    <div @click.stop="groupHandleQuantityForMainItem(item, 2, category.id, index3, index4, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                    </div>
                                  </div>
                              </div>
                              <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;position: absolute;right: 0;bottom: 10px;align-items: center;justify-content: center;display: flex;">
                                <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                              </div>
                              <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click.stop="groupOpenBoxChangeQuantityForItemWithoutModifier(index3, index4, index, item, category.id)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                              </div>
                              <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="grid border-0" v-else>
                          <div class="row ms-0 me-0 row-flex">
                            <div
                              class="col-6"
                              :class="{ 'ps-0': index5 % 2 == 0, 'pe-0': index5 % 2 == 1 }"
                              v-for="(item, index5) in group.items"
                              :key="index5"
                              @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                            >
                              <div class="col-12 text-center item-info h-100" :class="['item-img-' + category.id + '-' + group.id + '-' + item.id, { 'item-not-available': !checkAvailableItem(item) }]" style="position: relative">
                                <img
                                :src="item.image"
                                  alt="error"
                                  style="width:100%;"
                                />
                                <div class="mt-2" style="line-height: normal;font-weight: unset;font-size: 15px;">{{ tName(item.item_name) }}</div>
                                <div style="display: flex;gap: 3px;margin-top: 5px;margin-bottom: 5px;align-items: center;justify-content: center;">
                                  <div class="txt_popular_grid" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                                  <div class="txt_popular_grid" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                                </div>
                                <div v-if="item.member_price != item.price_default">
                                  <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                  <div class="member-price" :class="{ 'active': isLogined }">
                                    <span v-if="isLogined" class="font-weight-normal fs-11">
                                      {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                                    </span>
                                    <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                                  </div>
                                </div>
                                <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                <div v-if="!checkAvailableItem(item)" style="color: var(--moo-error, #eb2f06);font-size: 14px;">{{ $t('order.notAvailable') }}</div>
                                <div class="change-item-qty add-more-item">
                                  <div class="d-flex justify-content-center">
                                    <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                        <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                          <div @click.stop="groupOpenBoxChangeQuantityForItemWithoutModifier(index3, index5, index, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                            <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                          </div>
                                        </div>
                                    </div>
                                    <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                        <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                          <div @click.stop="groupHandleQuantityForMainItem(item, 1, category.id, index3, index5, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                            <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                          </div>
                                          <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                            <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                                          </div>
                                          <div @click.stop="groupHandleQuantityForMainItem(item, 2, category.id, index3, index5, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                            <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                          </div>
                                        </div>
                                    </div>
                                    <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                        <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                          <div @click.stop="groupHandleQuantityForMainItem(item, 1, category.id, index3, index5, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                            <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                          </div>
                                          <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                            <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                          </div>
                                          <div @click.stop="groupHandleQuantityForMainItem(item, 2, category.id, index3, index5, index)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                            <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                          </div>
                                        </div>
                                    </div>
                                    <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;align-items: center;justify-content: center;">
                                      <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                                    </div>
                                    <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click.stop="groupOpenBoxChangeQuantityForItemWithoutModifier(index3, index5, index, item, category.id)" style="width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                    </div>
                                    <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                      <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="group.sub_groups && group.sub_groups.length">
                        <div class="item-list" v-for="(subGroup, index6) in group.sub_groups" :key="index6">
                          <div>
                            <div class="tag-name-sub-group">
                              {{ tName(subGroup.name) }}
                            </div>
                            <div class="list border-0" v-if="typeList == 1">
                              <div
                                class="item-tag"
                                v-for="(item, index7) in subGroup.sub_group_items"
                                :key="index7"
                                @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                                :class="{ 'selectedItem': getTotalQuantityById(item.id) > 0 }" 
                                style="position: relative;"
                              >
                                <div :style="{ position: 'relative', opacity: !checkAvailableItem(item) ? 0.5 : 1 }">
                                  <div class="item-img" :class="'item-img-' + category.id + '-' + group.id + '-' + subGroup.id + '-' + item.id">
                                    <img :src="item.image" width="100" height="100" alt="error" style="border-radius: 5px;" />
                                  </div>
                                  <div class="item-info ms-2 w-100" style="height: 100%;">
                                    <div style="line-height: normal;font-weight: unset;margin-top: -3px;font-size: 15px;">{{ tName(item.item_name) }}</div>
                                    <div style="margin-top: 5px;">{{ subLine(item) }}</div>
                                    <div class="mt-1">
                                      <div v-if="item.member_price != item.price_default">
                                        <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                        <div class="member-price" :class="{ 'active': isLogined }">
                                          <span v-if="isLogined" class="font-weight-normal fs-11">
                                            {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                                          </span>
                                          <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                                        </div>
                                      </div>
                                      <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                      <div style="display: flex;gap: 10px;">
                                        <div class="txt_popular" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                                        <div class="txt_popular" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                                      </div>
                                    </div>
                                    <div v-if="!checkAvailableItem(item)" style="color: var(--moo-error, #eb2f06);font-size: 14px;width: 100%;">{{ $t('order.notAvailable') }}</div>
                                  </div>
                                </div>
                                <div class="change-item-qty">
                                  <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || subGroup.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                                      <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                        <div @click.stop="subGroupOpenBoxChangeQuantityForItemWithoutModifier(index3, index7, index, index6, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                          <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || subGroup.quantity) }}</span>
                                        </div>
                                      </div>
                                  </div>
                                  <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                                      <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                        <div @click.stop="subGroupHandleQuantityForMainItem(item, 1, category.id, index3, index7, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                          <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                        </div>
                                        <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                          <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                                        </div>
                                        <div @click.stop="subGroupHandleQuantityForMainItem(item, 2, category.id, index3, index7, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                          <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                        </div>
                                      </div>
                                  </div>
                                  <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || subGroup.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;position: absolute;right: 0px;bottom: 10px;border: 1px solid var(--color);border-radius: 50px;">
                                      <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                        <div @click.stop="subGroupHandleQuantityForMainItem(item, 1, category.id, index3, index7, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                          <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                        </div>
                                        <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                          <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || subGroup.quantity) }}</span>
                                        </div>
                                        <div @click.stop="subGroupHandleQuantityForMainItem(item, 2, category.id, index3, index7, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                          <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                        </div>
                                      </div>
                                  </div>
                                  <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;position: absolute;right: 0;bottom: 10px;align-items: center;justify-content: center;display: flex;">
                                    <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                                  </div>
                                  <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click.stop="subGroupOpenBoxChangeQuantityForItemWithoutModifier(index3, index7, index, index6, item, category.id)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                    <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                  </div>
                                  <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="position: absolute;right: 0px;bottom: 10px;width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                    <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="grid border-0" v-else>
                              <div class="row ms-0 me-0 row-flex">
                                <div
                                  class="col-6"
                                  :class="{ 'ps-0': index8 % 2 == 0, 'pe-0': index8 % 2 == 1 }"
                                  v-for="(item, index8) in subGroup.sub_group_items"
                                  :key="index8"
                                  @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                                >
                                  <div class="col-12 text-center item-info h-100" :class="['item-img-' + category.id + '-' + group.id + '-' + subGroup.id + '-' + item.id, { 'item-not-available': !checkAvailableItem(item) }]" style="position: relative">
                                    <img
                                    :src="item.image"
                                      alt="error"
                                      style="width:100%;"
                                    />
                                    <div class="mt-2" style="line-height: normal;font-weight: unset;font-size: 15px;">{{ tName(item.item_name) }}</div>
                                    <div style="display: flex;gap: 3px;margin-top: 5px;margin-bottom: 5px;align-items: center;justify-content: center;">
                                      <div class="txt_popular_grid" v-if="checkAndReturnPopular(item.tags)">{{ checkAndReturnPopular(item.tags) }}</div>
                                      <div class="txt_popular_grid" v-if="checkAndReturnSignature(item.tags)">{{ checkAndReturnSignature(item.tags) }}</div>
                                    </div>
                                    <div v-if="item.member_price != item.price_default">
                                      <div class="price-defalut" :class="{ 'active': !isLogined }" :style="{ 'text-decoration': isLogined ? 'line-through' : 'none' }"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                      <div class="member-price" :class="{ 'active': isLogined }">
                                        <span v-if="isLogined" class="font-weight-normal fs-11">
                                          {{ $t('order.memberPrice') }} <span class="price"><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.member_price) }}</span>
                                        </span>
                                        <span v-else class="font-weight-normal font-italic fs-11">{{ $t('order.memberPriceAvailable') }}</span>
                                      </div>
                                    </div>
                                    <div v-else class="price-defalut active"><span v-if="scheduleStruckPrice(item)" class="schedule-struck">{{ formatPrice(scheduleStruckPrice(item)) }}</span><span v-if="item.is_sub_category" class="from-label">{{ $t('order.from') + ' ' }}</span>{{ formatPrice(item.price_default) }}</div>
                                    <div v-if="!checkAvailableItem(item)" style="color: white;font-size: 14px;">{{ $t('order.notAvailable') }}</div>
                                    <div class="change-item-qty add-more-item">
                                      <div class="d-flex justify-content-center">
                                        <div v-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && !item.openingEditQuantity" style="border: 0px;width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                            <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                              <div @click="subGroupOpenBoxChangeQuantityForItemWithoutModifier(index3, index8, index, index6, null, null)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                                <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                              </div>
                                            </div>
                                        </div>
                                        <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                            <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                              <div @click.stop="subGroupHandleQuantityForMainItem(item, 1, category.id, index3, index8, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                                <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                              </div>
                                              <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                                <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) }}</span>
                                              </div>
                                              <div @click.stop="subGroupHandleQuantityForMainItem(item, 2, category.id, index3, index8, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                                <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                              </div>
                                            </div>
                                        </div>
                                        <div v-else-if="checkAvailableItem(item) && (getTotalQuantityById(item.id) || category.quantity) > 0 && item.isHaveModifierOptionGroups == 0 && item.openingEditQuantity" style="border: 0px;width: auto;height: 30px;border: 1px solid var(--color);border-radius: 50px;">
                                            <div style="width: auto;display: flex;align-items: center;justify-content: center;border:0px;">
                                              <div @click.stop="subGroupHandleQuantityForMainItem(item, 1, category.id, index3, index8, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                                <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">-</span>
                                              </div>
                                              <div style="border:0px;min-width: 20px;height: 30px;align-items: center;justify-content: center;display: flex;margin-right: 5px;">
                                                <span style="color: var(--color);font-size: 13.1px;">{{ (getTotalQuantityById(item.id) || category.quantity) }}</span>
                                              </div>
                                              <div @click.stop="subGroupHandleQuantityForMainItem(item, 2, category.id, index3, index8, index, index6)" style="border:0px;width: 30px;height: 30px;align-items: center;justify-content: center;display: flex;">
                                                <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                              </div>
                                            </div>
                                        </div>
                                        <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) > 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;border: 1px solid var(--color);border-radius: 30px;align-items: center;justify-content: center;">
                                          <span style="color: var(--color);font-size: 13.1px;">{{ getTotalQuantityById(item.id) > 99 ? "99+" : getTotalQuantityById(item.id) }}</span>
                                        </div>
                                        <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups == 0" @click="subGroupOpenBoxChangeQuantityForItemWithoutModifier(index3, index8, index, index6, item, category.id)" style="width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                          <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                        </div>
                                        <div v-else-if="checkAvailableItem(item) && getTotalQuantityById(item.id) == 0 && item.isHaveModifierOptionGroups > 0" @click="gotoOrderDetail(category.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)" style="width: 30px;height: 30px;background-color: transparent;border: 1px solid var(--color) !important;border-radius: 30px;align-items: center;justify-content: center;display: flex;">
                                          <span style="color: var(--color);font-size: 23px;margin-bottom: 2.5px;">+</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 message-success" style="z-index: 99999 !important">
        <material-snackbar
          v-if="snackbarAsMember === 'danger' || snackbarAsMember === 'success'"
          title=""
          date=""
          :description="messageAsMember"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbarAsMember"
          :close-handler="closeSnackbarAsMember"
        />
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
    </div>
    </div>
    <footer>
      <Footer
        :isYourFriendLogined="isYourFriendLogined"
        @check-show-upsell-items="checkShowUpsellItems"
      ></Footer>
    </footer>
    <MemorizeYourBirthday />
    <material-loading :active="loaderActive"/>
    <material-loading-without-animation :active="loaderActiveWithoutAnimation" />
    <ModalCustomization :categoryId="categoryIdSelect" :itemId="itemIdSelect" :itemDetail="itemDetail" :isLogined="isLogined" :reloadModal="reloadModal" @clear-data-item="clearDataItem"/>
    <ModalNotification :message="'Your friend signed in as a Member!'"/>
    <ModalConfirm :message="txtConfirm" :process-yes="processConfirmYes" :theme2="true"/>
    <ModalChooseNumberOfGuests :branchCode="branchCode" :tableCode="tableCode"/>
    <ModalSelectDiningOption
      :diningLocation="dining_location"
      :selectDiningOption="selectDiningOption"
      :isKiosk="false"
    />
    <ModalSelectPickupDelivery @select="selectPickupDelivery" />
    <ModalUpsellItems
      :upsellItems="upsellItems"
      @upsell-items-selected="handleUpsellItemsSelected"
      @no-thanks-clicked="handleNoThanksClicked"
    />
    <MenuPromoPopup
      v-model="showPromoPopup"
      :slide="promoSlide"
      :item="promoItem"
      :accent-color="promoAccentColor"
      @open-link="clickLink"
      @add-to-cart="onPromoAddToCart"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import OrderTopBar from "@/components/OrderTopBar.vue";
import CategorySidebar from "@/components/CategorySidebar.vue";
import OrderService from "../services/order.service";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle";
import MemorizeYourBirthday from "../components/MemorizeYourBirthday.vue";
import Footer from "@/common/Footer/OrderFooter";
import MaterialLoading from '@/components/MaterialLoading.vue';
import ModalCustomization from './ModalCustomization.vue';
import EventBus from "vue3-eventbus";
import MaterialLoadingWithoutAnimation from '@/components/MaterialLoadingWithoutAnimation.vue';
import { localStorageName, getDiningOption, clearCartIfPendingPaymentPaid, ensureMerchantId } from '@/config/utils';
import ModalNotification from '@/components/ModalNotification.vue';
import ModalConfirm from '@/components/ModalConfirm.vue';
import ModalChooseNumberOfGuests from '@/components/ModalChooseNumberOfGuests.vue';
import ModalSelectDiningOption from './kiosk/components/ModalSelectDiningOption.vue';
import ModalSelectPickupDelivery from './components/ModalSelectPickupDelivery.vue';
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import ModalUpsellItems from './components/ModalUpsellItems.vue';
import MenuBanner from './components/MenuBanner.vue';
import MenuPromoPopup from './components/MenuPromoPopup.vue';
import { MENU_POPUP_SESSION_KEY } from '@/config/const';
import { scheduleOriginalPrice } from '@/config/specialPrice';
import {
  collectItemNames,
  loadMenuTranslations,
  prefetchMenuTranslations,
  translatedName,
} from '@/i18n/menuTranslate';

SwiperCore.use([Pagination, Autoplay]);

export default {
  name: "Order",
  components: {
    Swiper,
    SwiperSlide,
    OrderTopBar,
    CategorySidebar,
    MemorizeYourBirthday,
    Footer,
    MaterialLoading,
    ModalCustomization,
    MaterialLoadingWithoutAnimation,
    ModalNotification,
    ModalConfirm,
    MaterialSnackbar,
    ModalChooseNumberOfGuests,
    ModalSelectDiningOption,
    ModalSelectPickupDelivery,
    ModalUpsellItems,
    MenuBanner,
    MenuPromoPopup
  },
  data() {
    return {
      snackbarAsMember: null,
      messageAsMember: "",
      snackbar: null,
      message: "",
      // MTH097: message + pending action for the in-app remove-item confirm.
      txtConfirm: "",
      pendingConfirmAction: null,
      isLoadDone: false,
      loaderActive: false,
      merchantCode: "",
      memberInfo: JSON.parse(localStorage.getItem(localStorageName('memberInfo'), '')),
      branchCode: "",
      branch: JSON.parse(localStorage.getItem(localStorageName('BRANCH_INFO'), '')),
      pathType: "",
      tableCode: "",
      categories: [],
      categoryIdSelect: this.$route.params.category_id ?? 0,
      categorySelect: {},
      categoryIndexSelect: 0,
      groupSelect: null,
      typeList: 1,
      isSearch: false,
      searchKeyword: "",
      searchTimerId: null,
      itemSearch: [],
      slidesHomePage: [],
      showPromoPopup: false,
      promoSlide: null,
      promoItem: null,
      itemIdSelect: 0,
      itemDetail: {},
      reloadModal: 'reload-item-detail',
      heightOrderContent: 'unset',
      isLogined: false,
      isYourFriendLogined: false,
      indexScrollCategory: 0,
      beforeIndexScrollCategory: 0,
      cartName: 'ORDER_INFO',
      isLoadingGetItemDetail: false,
      tableInfo: {},
      loaderActiveWithoutAnimation: false,
      isSelectCategory: false,
      // M1045: banner has scrolled past -> show the slim sticky bar.
      isHeaderCompact: false,
      isCompactSearchFocus: false,
      textLostInternet: "Your internet connection has been lost, and items cannot be added to your cart at this time.",
      itemsAllowDisplay: [],
      queue: false,
      upsellItems: [],
      upsellBanners: [],
      // fly-to-cart animation state (ported from advocado SF022); null when idle
      flyState: null,
      flyRafId: null,
      dining_location: 0,
      takeAwayOrDineIn: 2, // 1 = take away | 2 = dine in
      isOrderPayLater: false
    };
  },
  setup() {
    const isOnline = ref(navigator.onLine);

    const updateOnlineStatus = () => {
      isOnline.value = navigator.onLine;
    };

    onMounted(() => {
      window.addEventListener('online', updateOnlineStatus);
      window.addEventListener('offline', updateOnlineStatus);
    });

    onUnmounted(() => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    });

    return {
      isOnline,
    };
  },
  beforeUnmount() {
    // Cancel any in-flight fly-to-cart tween so its rAF callback doesn't fire
    // after the component is gone, and drop the modal fly listener.
    if (this.flyRafId != null) {
      cancelAnimationFrame(this.flyRafId);
      this.flyRafId = null;
    }
    if (EventBus && typeof EventBus.off === "function") {
      EventBus.off("FlyToCart", this.onFlyToCart);
    }
    window.removeEventListener("pageshow", this.handlePageShow);
  },
  async created() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    this.pathType = this.$route.params.type;
    this.tableCode = this.$route.params.table_code;
    this.cartName = await this.$store.dispatch('cartName');
    this.tableInfo = JSON.parse(localStorage.getItem('table_' + (this.merchantCode || '').toLowerCase() + '_' + (this.branchCode || '').toLowerCase() + '_' + (this.tableCode || '').toLowerCase(), {}));
    const routeName = this.$route.name;

    if (routeName == 'Queue') {
      this.queue = true;
      this.cartName = this.cartName.replace('ORDER_INFO_', 'ORDER_QUEUE_INFO_');
    }

    if (this.memberInfo) {
      this.isYourFriendLogined = false;
    } else {
      if (this.tableInfo) {
        this.isYourFriendLogined = this.queue ? false : this.tableInfo.is_member_order ?? false;
      }
    }

    if(this.memberInfo || this.isYourFriendLogined) {
      this.isLogined = true;
    }

    if (this.tableInfo) {
      if (this.tableInfo.stripe_connect) {
          this.isOrderPayLater = false;
      } else {
          this.isOrderPayLater = true;
      }
    } else {
        this.isOrderPayLater = false;
    }

    // Not awaited - only takes any visible action (clears the cart, redirects to
    // payment-success) if it actually finds a confirmed-paid pending transaction, which
    // is the rare case, so there's nothing here worth blocking the rest of created() on.
    clearCartIfPendingPaymentPaid(this.cartName, this.branchCode, {
      tableInfo: this.tableInfo,
      tableCode: this.tableCode,
    });
  },
  async mounted() {
    $(".modal-backdrop.fade.show").remove();

    const memorize = this.$route.params.memorize ?? null;
    if (memorize) {
      $(".bottom_modal_memorize").click();
    }

    // On SPA navigation (e.g. tab into Order after login) data() may have read
    // BRANCH_INFO before the store's merchant/branch codes were populated, leaving
    // this.branch null. Re-hydrate it now that the codes are available so the
    // dining-option gate below doesn't crash on a null branch.
    if (!this.branch) {
      this.branch = JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO")) || "null"
      );
    }

    // Back/forward navigation can restore this page from the browser's bfcache instead
    // of reloading it - created() does not run again in that case, so re-check pending
    // payment status explicitly (e.g. customer reloaded/lost connection mid-checkout,
    // landed on a blank page, then hit "back").
    window.addEventListener("pageshow", this.handlePageShow);

    if (this.merchantCode && this.branchCode) {
      try {
        await this.getListCategory(1, true);
        await this.getSlidesHomePage();
        this.fetchUpsellBanners();
      } catch (e) {
        console.log(e);
        this.hideLoader();
      }
    }

    if (this.isYourFriendLogined && !this.queue) {
      // $('.btn-notification-modal').click(); 
      this.snackbarAsMember = "success";
      this.messageAsMember = "Your friend signed in as a Member!";
      this.setTimeOutNotificationAsMember();
    }

    $(window).on('resize', this.resizeLayout);

    // EventBus.on('AddToCartThenReloadCategorySuccess', e => e.time == this.reloadModal && this.getListCategory(2)  )

    EventBus.on("AddToCartThenReloadCategorySuccess", (e) => {
      setTimeout(() => {
        if(e.time == this.reloadModal) {
          this.getListCategory(2, false)
        }
      }, 300);
    });

    // fly-to-cart from the item-detail modal add button
    EventBus.on("FlyToCart", this.onFlyToCart);

    const savedDiningOption = localStorage.getItem(localStorageName("DINING_OPTION"));
    if (this.branch && this.branch.show_dining_option_moo && !this.isOrderPayLater && savedDiningOption === null) {
      $('.btn-show-modal-select-dining-option').click();
    } else if (this.shouldAskPickupOrDelivery()) {
      // M986 follow-up: Pickup or Delivery is asked once, before the customer orders.
      $('.btn-show-modal-select-pickup-delivery').click();
    } else {
      // Restore the dining option chosen earlier in this session — otherwise
      // takeAwayOrDineIn silently stays at its "Dine In" default on reload.
      if (savedDiningOption !== null) {
        this.takeAwayOrDineIn = Number(savedDiningOption);
      }
      if (this.tableInfo && !this.tableInfo.pax_selected && this.tableInfo.show_number_of_pax) {
        $('.btn-choose-number-of-guests-modal').click();
      }
    }

    window.onpopstate = (e) => {
      if (this.itemIdSelect) {
        e.preventDefault();
        history.go(1);
      }
    };
  },
  computed: {
    styleObject() {
      const base =
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a";
      return {
        // Theme 2 colour drives every `var(--color)` usage on the Order screen
        // (item cards, filled +/qty buttons, category highlight, price badges).
        "--color": base,
        // Near-white surfaces with only a faint brand warmth: the brand colour
        // stays an ACCENT (via --color), so the page background, top bar, sidebar
        // and cards read almost white instead of a heavy tint. Search/pill field
        // gets the most so it still reads as an input.
        "--theme-20": this.blendWhite(base, 0.04),
        "--theme-30": this.blendWhite(base, 0.0675),
        "--theme-40": this.blendWhite(base, 0.16),
      };
    },
    // MTH045: accent colour for the post-login promo popup (theme2 tone).
    promoAccentColor() {
      return (
        this.$store.state.mainThemeColorTheme2 ||
        this.$store.state.color ||
        "#201a1a"
      );
    },
    // Inline style for the fly-to-cart element (advocado SF022). Recomputed
    // every frame while flyState mutates; position:fixed tracks viewport coords.
    flyStyle() {
      if (!this.flyState) return {};
      const { x, y, w, h, scale, opacity, imageUrl } = this.flyState;
      return {
        position: "fixed",
        left: `${x}px`,
        top: `${y}px`,
        width: `${w}px`,
        height: `${h}px`,
        transform: `scale(${scale})`,
        transformOrigin: "center center",
        opacity,
        // Fallback tint keeps the fly visible even when the item image is
        // missing/broken; the image (when it loads) covers this.
        backgroundColor: "var(--color, #d0d0d0)",
        backgroundImage: imageUrl ? `url("${imageUrl}")` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "12px",
        boxShadow: "0 6px 16px rgba(0, 0, 0, 0.18)",
        pointerEvents: "none",
        zIndex: 99999,
        willChange: "transform, opacity, left, top",
      };
    },
  },
  methods: {
    // KSK119 on MOO / QR: while a price schedule sells the item (a Choice item: its first choice)
    // below its usual price, that usual price - the member one for a signed-in member - is
    // struck through next to it. 0 otherwise.
    scheduleStruckPrice(item) {
      const original = scheduleOriginalPrice(item, this.isLogined);
      return original > (parseFloat(item.price_default) || 0) ? original : 0;
    },
    formatPrice(price) {
      return '$ ' + parseFloat(price).toFixed(2);
    },

    handlePageShow(event) {
      if (event.persisted) {
        clearCartIfPendingPaymentPaid(this.cartName, this.branchCode, {
          tableInfo: this.tableInfo,
          tableCode: this.tableCode,
        });
      }
    },

    clearDataItem() {
      this.itemIdSelect = 0;
      this.itemDetail = {};
    },

    handleScroll(event) {
      const container = event.target;
      // M1045: once the banner's search row is out of view, the slim bar takes over.
      if (this.$refs.hero) {
        this.isHeaderCompact = container.scrollTop > this.$refs.hero.offsetHeight - 50;
      }

      // While a sidebar-tap smooth-scroll is running, don't let scroll-spy
      // override the user's chosen category.
      if (this.isSelectCategory) return;

      const scrollPosition = container.scrollTop;
      const maxScrollPosition = container.scrollHeight - container.clientHeight;
      const sections = document.querySelectorAll('.tag-name-category');
      if (!sections.length) return;

      let active;
      if (Math.round(scrollPosition) >= Math.round(maxScrollPosition) - 1) {
        // At the very bottom, the last category owns the highlight.
        active = sections.length - 1;
      } else {
        // Otherwise the last section whose top has passed the header line is
        // the category currently in view.
        active = 0;
        sections.forEach((section, index) => {
          if (scrollPosition >= section.offsetTop - 70) active = index;
        });
      }

      if (active !== this.categoryIndexSelect) {
        this.categoryIndexSelect = active;
      }
    },

    resizeLayout() {
      setTimeout(() => {
        this.heightOrderContent = $( window ).height() - 112 - $('.banner').height() - $('.root_container').height();
        $('.content-custom').height(this.heightOrderContent);

        if (this.typeList == 1) {
          // $('.category-list').height(this.heightOrderContent - (this.heightOrderContent / 2) + 50);
          // $('.category-list').height('unset');
        } else {
          $('.category-list').height('unset');
        }
      }, 200)
    },

    shouldAskPickupOrDelivery() {
      return !!(
        this.branch &&
        this.branch.show_pickup_delivery_option_moo == 1 &&
        // M995: a channel offering only Pickup or only Delivery has nothing to ask.
        ![1, 2].includes(Number(this.branch.pickup_delivery_mode)) &&
        !this.isOrderPayLater &&
        !this.queue &&
        localStorage.getItem(localStorageName("PICKUP_DELIVERY_ASKED")) === null
      );
    },
    // M986 follow-up: 1 = Pickup, 2 = Delivery, 0 = just browsing. The choice goes where
    // MyCart keeps its Pickup/Delivery toggle, so the cart opens on it.
    async selectPickupDelivery(value) {
      localStorage.setItem(localStorageName("PICKUP_DELIVERY_ASKED"), "1");
      if (value !== 1 && value !== 2) {
        return;
      }

      const cartName = await this.$store.dispatch("cartName");
      const key = localStorageName(`CART_FORM_STATE_${cartName}`);
      let state = {};
      try {
        state = JSON.parse(localStorage.getItem(key)) || {};
      } catch (e) {
        state = {};
      }
      state.btnSelected = value;
      localStorage.setItem(key, JSON.stringify(state));
    },
    selectDiningOption(value) {
      this.takeAwayOrDineIn = value;
      $(".btn-hide-modal-select-dining-option").click();
      localStorage.setItem(
        localStorageName("DINING_OPTION"),
        this.takeAwayOrDineIn
      );
      // Footer cart pill adds the service charge on dine-in only.
      EventBus.emit("DiningOptionChanged");

      if (this.tableInfo && !this.tableInfo.pax_selected && this.tableInfo.show_number_of_pax) {
        $('.btn-choose-number-of-guests-modal').click();
      }
    },

    async gotoOrderDetail(categoryId, id, stock_balance, is_not_available, stock_enable_balance, item) {
      // console.log(stock_balance, is_not_available, stock_enable_balance, item)
      // if(this.checkAvailableItem(item) && item.isHaveModifierOptionGroups > 0) {
      if(this.checkAvailableItem(item)) {
        // MTH080: tapping an item can happen a long time after page load, well
        // past the mount-time heal's window — re-check right before the call.
        await ensureMerchantId(this.branchCode);
        this.categoryIdSelect = categoryId
        this.itemIdSelect = id;

        // this.showLoader();
        let dataForm = {
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: categoryId,
          item_id: id,
          branch_code: this.branchCode,
          take_away_or_dine_in: this.takeAwayOrDineIn,
          is_kiosk: 0
        };

        OrderService.getItemDetail(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.itemDetail = response.data.data;
              this.reloadModal = Math.random(32).toString();
              $('.btn-show-item-detail-modal').click();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
          }
        );
      }
    },

    scrollCenterHorizontal(index, id) {
      if (index > 1) {
        const screenWidth = $( window ).width();
        setTimeout(() => {
          $('.category-list').animate({
            scrollLeft: $('#category-tag-' + id).offset().left + $('.category-list').scrollLeft() - (screenWidth / 3) - 20
          }, 300);
        }, 100);
      } else {
        setTimeout(() => {
          $('.category-list').animate({
            scrollLeft: 0
          }, 300);
        }, 100);
      }
    },

    onSidebarSelect({ category, index }) {
      this.selectCategory(category, index);
    },
    // Blend a #rrggbb theme colour with white at the given theme ratio, giving
    // an opaque colour equal to `theme @ ratio` composited over white.
    blendWhite(color, ratio) {
      // Accept #rrggbb, #rgb, or rgb()/rgba() — the merchant-admin colour picker
      // may persist any of these. Only bail if we truly can't parse it.
      if (typeof color !== "string") return color;
      const s = color.trim();
      let r, g, b, m;
      if ((m = s.match(/^#([0-9a-fA-F]{6})$/))) {
        r = parseInt(m[1].slice(0, 2), 16);
        g = parseInt(m[1].slice(2, 4), 16);
        b = parseInt(m[1].slice(4, 6), 16);
      } else if ((m = s.match(/^#([0-9a-fA-F]{3})$/))) {
        r = parseInt(m[1][0] + m[1][0], 16);
        g = parseInt(m[1][1] + m[1][1], 16);
        b = parseInt(m[1][2] + m[1][2], 16);
      } else if ((m = s.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)/i))) {
        r = +m[1];
        g = +m[2];
        b = +m[3];
      } else {
        return color;
      }
      const mix = (c) => Math.round(ratio * c + (1 - ratio) * 255);
      const h = (v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, "0");
      return "#" + h(mix(r)) + h(mix(g)) + h(mix(b));
    },
    selectCategory(category, index, isFirstLoad = false) {
      this.categorySelect = category;
      this.categoryIndexSelect = index;
      this.groupSelect = null;
      this.isSelectCategory = true;

      setTimeout(() => {
        var offsetTop = 0;
        $('#tag-name-category-' + category.id).each((index, element) => {
          offsetTop = element.offsetTop;
        })

        var scrollPosition = $('.content-custom').scrollTop();
        var maxScrollPosition = $('.content-custom').prop('scrollHeight') - $('.content-custom').outerHeight();
        
        if (scrollPosition == Math.round(maxScrollPosition)) {
          $('.category-tag').removeClass('active');
          $('#category-tag-' + category.id).addClass('active');
          this.categoryActive = true;
        }

        $('.content-custom').animate({
          scrollTop: offsetTop - 60
        }, 500);
      }, isFirstLoad ? 500 : 0);

      setTimeout(() => {
        this.isSelectCategory = false;
      }, isFirstLoad ? 1000 : 500)
    },

    selectGroup(group) {
      this.groupSelect = group;
      if (this.typeList == 2) {
        $(".group-list > .group-tag").removeClass("active");
        $("#group-tag-" + group.id).addClass("active");
        $('.content-custom').scrollTop(0,0);
        $('.content-custom').animate({
          scrollTop: $('.tag-name-group-' + group.id).offset().top - 80
        }, 500);
      } else {
        $(".group-list > .group-tag").removeClass("active");
        $("#group-tag-" + group.id).addClass("active");
        $('.content-custom').scrollTop(0,0);
        setTimeout(() => {
          $('.content-custom').animate({
            scrollTop: $('.tag-name-group-' + group.id).offset().top - (110 - $('.order-header').height())
          }, 500);
        }, 100)
      }
    },

    changeTypeList(type) {
      this.typeList = type;
    },

    // Menu item / category / group names come from the POS in the source
    // language; this returns the translation for the active locale (or the
    // original while it loads, or on English).
    tName(source) {
      return translatedName(source);
    },

    // Second line under an item's name. While a foreign language is displayed
    // the name itself is translated, so this line carries the ENGLISH source
    // name instead of the merchant description — the customer can still match
    // the dish against the printed/English menu. On English it stays the
    // merchant's own description.
    subLine(item) {
      if (this.$i18n.locale !== "en") {
        return item.item_name || item.name || "";
      }
      return item.description || "";
    },

    // Fetch translations for every name currently on screen. Called after the
    // menu or a search result loads, and whenever the top bar switches language.
    syncMenuNames() {
      const names = collectItemNames([
        ...(this.categories || []),
        ...(this.itemSearch || []),
        // MTH047: upsell banner rows come from a separate feed, so their names
        // are not covered by the category walk.
        ...(this.upsellBanners || []),
      ]);
      loadMenuTranslations(names, this.$i18n.locale);
      // M1044: have every language ready before the customer switches.
      prefetchMenuTranslations(names);
    },

    async getListCategory(type, isLoadingAnimation) {
      if(isLoadingAnimation) {
        this.showLoader();
      }
      // Guard: if branch info isn't ready, re-hydrate from localStorage. On SPA
      // navigation (e.g. tab into Order after login) App.vue never re-runs, so it
      // may not have written BRANCH_INFO for this merchant/branch — in that case
      // fetch it directly (same endpoint App.vue uses) and cache it, so the menu
      // loads instead of showing an empty screen.
      if (!this.branch) {
        this.branch = JSON.parse(
          localStorage.getItem(localStorageName('BRANCH_INFO')) || 'null'
        );
      }
      // MTH080: logout wipes localStorage (Profile.handleLogout) and App.vue never
      // re-runs on SPA navigation, so MERCHANT_ID can be gone too. The interceptor
      // reads that header from localStorage and every /order endpoint sits behind
      // jwt.merchant_id_and_code — without it the menu comes back empty. Re-fetch
      // whenever either piece is missing, and cache both.
      const merchantIdMissing = !localStorage.getItem(localStorageName('MERCHANT_ID'));
      if ((!this.branch || merchantIdMissing) && this.branchCode) {
        try {
          const resp = await OrderService.checkMerchantAndBranch({
            branch_code: this.branchCode,
          });
          if (resp.data.result.isSuccess) {
            if (merchantIdMissing) {
              localStorage.setItem(
                localStorageName('MERCHANT_ID'),
                resp.data.data.merchant_id ?? 0
              );
            }
            if (resp.data.data.branch_info) {
              this.branch = resp.data.data.branch_info;
              localStorage.setItem(
                localStorageName('BRANCH_INFO'),
                JSON.stringify(this.branch)
              );
            }
          }
        } catch (e) {
          // fall through to the bail-out below
        }
      }
      if (!this.branch) {
        this.snackbar = "danger";
        this.message = "Unable to load branch information. Please try again.";
        this.setTimeOutNotification();
        this.hideLoader();
        return;
      }
      let dataForm = {
        menuset_id: this.branch.menuset_id ?? 0,
        branch_code: this.branch.branch_code ?? ''
      };

      await OrderService.getListCategory(dataForm).then(
        (response) => {
          try {
            if (response.data.result.isSuccess) {
              this.isLoadDone = true;
              this.categories = response.data.data.categories;
              this.itemsAllowDisplay = response.data.data.items_allow_display;
              this.dining_location = response.data.data.dining_location_moo;
              // Cache alongside DINING_OPTION so other screens (MyCart) can tell
              // whether both dine-in/takeaway are actually offered right now,
              // without re-deriving it from branch settings (which can drift
              // from the order-context-aware value the menu API returns).
              localStorage.setItem(
                localStorageName("DINING_LOCATION"),
                this.dining_location
              );
              this.syncMenuNames();

              if(type == 1) {
                if (this.categories.length) {
                  if (this.categoryIdSelect) {
                    this.categories.forEach((category, index) => {
                      if (this.categoryIdSelect == category.id) {
                        this.selectCategory(category, index, true)
                        return;
                      }
                    });
                  } else {
                    this.categorySelect = this.categories[0];
                    this.categoryIndexSelect = 0;
                    setTimeout(() => {
                      $('.tag-name-category-' + this.categorySelect.id).addClass('active');
                    }, 100)
                  }
                }
              }
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
          } finally {
            this.hideLoader();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    onChangesearchKeyword(value) {
      this.searchKeyword = value;
      if (this.searchKeyword.trim() == "") {
        this.isSearch = false;
      } else {
        this.isSearch = true;
        clearTimeout(this.searchTimerId);
        this.searchTimerId = setTimeout(() => {
          this.searchItem();
        }, 1000);
      }
    },

    searchItem() {
      this.showLoader();
      let dataForm = {
        menuset_id: this.branch.menuset_id ?? 0,
        search_keyword: this.searchKeyword,
        branch_code: this.branchCode,
        items_allow_display: this.itemsAllowDisplay
      };

      OrderService.searchItem(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.itemSearch = response.data.data;
            this.syncMenuNames();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    // gotoMyReward() {
    //   this.$router.push({ name: "MyReward", params: {
    //     merchant_code: this.merchantCode,
    //     type: this.pathType,
    //     branch_code: this.branchCode,
    //     table_code: this.tableCode
    //   } });
    // },

    checkAndReturnPopular(array) {
      if(array && array.length > 0) {
        if (array.includes("Popular")) {
          return "Popular";
        } else {
          return "";
        }
      }
      return "";
    },

    checkAndReturnSignature(array) {
      if(array && array.length > 0) {
        if (array.includes("Signature")) {
          return "Signature";
        } else {
          return "";
        }
      }
      return "";
    },

    async getSlidesHomePage() {
      this.showLoader();
      await ensureMerchantId(this.branchCode);
      var dataForm = {
        isMintyApi: true,
        branch_code: this.branchCode,
        where_showing: 1,
        is_ordering_online: 1
      }
      await OrderService.getSlidesHomePage(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.slidesHomePage = response.data.data
            // MTH045: greet the user with the first promo slide once per login.
            // MTH061: temporarily disabled — no post-login promo popup on the
            // menu page. Uncomment the call below to bring it back.
            // this.maybeShowPromoPopup();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    // MTH045: session-scoped, namespaced gate so the promo popup shows exactly
    // once per login. SignIn re-arms it by clearing this key on a fresh login.
    promoPopupSessionKey() {
      return localStorageName(MENU_POPUP_SESSION_KEY);
    },
    async maybeShowPromoPopup() {
      try {
        if (sessionStorage.getItem(this.promoPopupSessionKey()) === "1") {
          return;
        }
        // Prefer a merchant-configured home slide (where_showing=1). When the
        // branch has no slide, fall back to the newest published menu item so
        // the menu still greets the user with a "new dish" popup (advocado parity).
        this.promoSlide = null;
        this.promoItem = null;
        const slide = this.resolvePromoSlide();
        if (slide) {
          this.promoSlide = slide;
        } else {
          this.promoItem = await this.resolveNewestItem();
        }
        if (!this.promoSlide && !this.promoItem) return;

        this.showPromoPopup = true;
        // Gate at show-time so it counts as shown the instant it appears, even
        // if the user lets it auto-close or navigates away mid-display.
        try {
          sessionStorage.setItem(this.promoPopupSessionKey(), "1");
        } catch (e) {
          // sessionStorage unavailable (private mode) — popup just won't re-suppress
        }
      } catch (e) {
        // graceful no-op: no popup
      }
    },
    resolvePromoSlide() {
      // First home slide (where_showing=1) that carries an image.
      const slide =
        Array.isArray(this.slidesHomePage) && this.slidesHomePage.length
          ? this.slidesHomePage.find((s) => s && s.file_url)
          : null;
      return slide || null;
    },
    async resolveNewestItem() {
      // MTH045: single newest published item (full shape) so the popup can show
      // name + price and open the item-detail modal on Add-to-cart. Skips $0 /
      // un-sellable items (advocado SF163) so the popup never surfaces a price-0
      // item; returns null on any failure so the popup is simply skipped.
      try {
        const res = await OrderService.getNewestItems({
          branch_code: this.branchCode,
          limit: 10,
        });
        if (!res?.data?.result?.isSuccess) return null;
        const list = Array.isArray(res.data.data?.list_item)
          ? res.data.data.list_item
          : [];
        return (
          list.find((item) => {
            if (!item || !item.id || !item.image) return false;
            // Skip by-weight items — they can't be added at a fixed price, so
            // fall through to the next-newest normal item.
            if (item.is_by_weight) return false;
            const price =
              parseFloat(item.member_price) ||
              parseFloat(item.price_default) ||
              parseFloat(item.price) ||
              0;
            return price > 0;
          }) || null
        );
      } catch (e) {
        return null;
      }
    },
    onPromoAddToCart(item) {
      if (!item || !item.id) return;
      this.showPromoPopup = false;
      // Reuse the shared menu item-tap flow (same as banner taps): opens the
      // item-detail modal so modifiers/quantity are handled correctly.
      this.onUpsellBannerTap(item);
    },

    clickLink(link) {
      if(link && link != "") {
        window.open(link);
      }
    },

    checkAvailableItem(item) {
      if(item.stock_enable_balance) { // countdown = true
          if(item.stock_balance > 0) {
              return true;
          } else {
              return false;
          }
      } else { // countdown = false
          if(item.is_not_available == 0) {
              return true;
          } else {
              return false;
          }
      }
    },

    getTotalQuantityById(id) {
      const data = JSON.parse(localStorage.getItem(this.cartName, []));
      let totalQuantity = 0;
      if(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
                totalQuantity += data[i].quantity;
            }
        }
      }
      return totalQuantity;
    },

    async handleQuantityForMainItem(mainItem, type, category_id, categoryIndex, itemIndex) { // 1 is - | 2 is +
      // MTH080: a "+" tap can happen a long time after page load — re-check
      // before the getItemDetail call below (type 2, item not yet in cart).
      await ensureMerchantId(this.branchCode);
      let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(item => item.id === mainItem.id);
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
            // MTH097: quantity is about to hit 0 — confirm through the in-app
            // themed modal instead of the browser's native alert.
            this.askRemoveItemConfirm(mainItem.item_name, () => {
              this.showLoader();
              this.categories[categoryIndex].items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              if (orderInfo[indexToAddQuantity].quantity == 0) {
                orderInfo.splice(indexToAddQuantity, 1);
              }
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("AddToCartSuccess");
            });
        } else {
          if(orderInfo[indexToAddQuantity]) {
            if(orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.categories[categoryIndex].items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if(orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(mainItem.id, itemIndex, category_id);
          this.showLoader();
          this.categories[categoryIndex].items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          try {
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          } catch (e) {
            console.log(e);
          }
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if(this.isLoadingGetItemDetail == false) {
            if(this.isOnline) {
              this.addCartAnimation(mainItem.id, itemIndex, category_id);
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 0,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.categories[categoryIndex].items[itemIndex].quantity = 1;
                    let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(itemDetail.price_default);
                    itemDetail.member_price = parseFloat(itemDetail.member_price);

                    orderInfo.push(itemDetail);
                    localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.textLostInternet);
            }
          }
        }
      }
    },
    openBoxChangeQuantityForItemWithoutModifier(categoryIndex, itemIndex, item, category_id) {
      for (const category of this.categories) {
          for (const item of category.items) {
            delete item.openingEditQuantity;
          }
      }
      this.categories[categoryIndex].items[itemIndex].openingEditQuantity = true;
      if(item) {
        this.handleQuantityForMainItem(item, 2, category_id, categoryIndex, itemIndex);
      }
    },
    async groupHandleQuantityForMainItem(mainItem, type, category_id, groupIndex, itemIndex, categoryIndex) { // 1 is - | 2 is +
      // MTH080: a "+" tap can happen a long time after page load — re-check
      // before the getItemDetail call below (type 2, item not yet in cart).
      await ensureMerchantId(this.branchCode);
      let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(item => item.id === mainItem.id);
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
            // MTH097: quantity is about to hit 0 — confirm through the in-app
            // themed modal instead of the browser's native alert.
            this.askRemoveItemConfirm(mainItem.item_name, () => {
              this.showLoader();
              this.categories[categoryIndex].groups[groupIndex].items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              if (orderInfo[indexToAddQuantity].quantity == 0) {
                orderInfo.splice(indexToAddQuantity, 1);
              }
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("AddToCartSuccess");
            });
        } else {
          if(orderInfo[indexToAddQuantity]) {
            if(orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.categories[categoryIndex].groups[groupIndex].items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if(orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(mainItem.id, itemIndex, this.categories[categoryIndex].id, this.categories[categoryIndex].groups[groupIndex].id);
          this.showLoader();
          this.categories[categoryIndex].groups[groupIndex].items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          try {
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          } catch (e) {
            console.log(e);
          }
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if(this.isLoadingGetItemDetail == false) {
            if(this.isOnline) {
              this.addCartAnimation(mainItem.id, itemIndex, this.categories[categoryIndex].id, this.categories[categoryIndex].groups[groupIndex].id);
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 0,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.categories[categoryIndex].groups[groupIndex].items[itemIndex].quantity = 1;
                    let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(itemDetail.price_default);
                    itemDetail.member_price = parseFloat(itemDetail.member_price);

                    orderInfo.push(itemDetail);
                    localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.textLostInternet);
            }
          }
        }
      }
    },
    groupOpenBoxChangeQuantityForItemWithoutModifier(groupIndex, itemIndex, categoryIndex, item, categoryId) {
      for (const category of this.categories) {
          for (const group of category.groups) {
            for (const item of group.items) {
              delete item.openingEditQuantity;
            }
          }
      }
      this.categories[categoryIndex].groups[groupIndex].items[itemIndex].openingEditQuantity = true;
      if(item) {
        this.groupHandleQuantityForMainItem(item, 2, categoryId, groupIndex, itemIndex, categoryIndex);
      }
    },
    async subGroupHandleQuantityForMainItem(mainItem, type, category_id, groupIndex, itemIndex, categoryIndex, subGroupIndex) { // 1 is - | 2 is +
      // MTH080: a "+" tap can happen a long time after page load — re-check
      // before the getItemDetail call below (type 2, item not yet in cart).
      await ensureMerchantId(this.branchCode);
      let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(item => item.id === mainItem.id);
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
            // MTH097: quantity is about to hit 0 — confirm through the in-app
            // themed modal instead of the browser's native alert.
            this.askRemoveItemConfirm(mainItem.item_name, () => {
              this.showLoader();
              this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].sub_group_items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              if (orderInfo[indexToAddQuantity].quantity == 0) {
                orderInfo.splice(indexToAddQuantity, 1);
              }
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("AddToCartSuccess");
            });
        } else {
          if(orderInfo[indexToAddQuantity]) {
            if(orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].sub_group_items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if(orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(mainItem.id, itemIndex, this.categories[categoryIndex].id, this.categories[categoryIndex].groups[groupIndex].id, this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].id);
          this.showLoader();
          this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].sub_group_items[itemIndex].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          try {
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          } catch (e) {
            console.log(e);
          }
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if(this.isLoadingGetItemDetail == false) {
            if(this.isOnline) {
              this.addCartAnimation(mainItem.id, itemIndex, this.categories[categoryIndex].id, this.categories[categoryIndex].groups[groupIndex].id, this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].id);
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 0,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].sub_group_items[itemIndex].quantity = 1;
                    let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(itemDetail.price_default);
                    itemDetail.member_price = parseFloat(itemDetail.member_price);

                    orderInfo.push(itemDetail);
                    localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.textLostInternet);
            }
          }
        }
      }
    },
    subGroupOpenBoxChangeQuantityForItemWithoutModifier(groupIndex, itemIndex, categoryIndex, subGroupIndex, item, categoryId) {
      for (const category of this.categories) {
          for (const group of category.groups) {
            for (const subGroup of group.sub_groups) {
              for (const item of subGroup.sub_group_items) {
                delete item.openingEditQuantity;
              }
            }
          }
      }
      this.categories[categoryIndex].groups[groupIndex].sub_groups[subGroupIndex].sub_group_items[itemIndex].openingEditQuantity = true;
      if(item) {
        this.subGroupHandleQuantityForMainItem(item, 2, categoryId, groupIndex, itemIndex, categoryIndex, subGroupIndex);
      }
    },
    openBoxChangeQuantityForItemWithoutModifierWhenSearch(itemIndex, item, category_id) {
      for (const item of this.itemSearch) {
        delete item.openingEditQuantity;
      }
      this.itemSearch[itemIndex].openingEditQuantity = true;
      if(item) {
        this.handleQuantityForMainItemWhenSearch(item, 2, itemIndex, category_id);
      }
    },
    async handleQuantityForMainItemWhenSearch(mainItem, type, itemIndex, category_id) { // 1 is - | 2 is +
      // MTH080: a "+" tap can happen a long time after page load — re-check
      // before the getItemDetail call below (type 2, item not yet in cart).
      await ensureMerchantId(this.branchCode);
      let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(item => item.id === mainItem.id);
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
            // MTH097: quantity is about to hit 0 — confirm through the in-app
            // themed modal instead of the browser's native alert.
            this.askRemoveItemConfirm(mainItem.item_name, () => {
              this.showLoader();
              this.itemSearch[itemIndex].quantityNew = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              if (orderInfo[indexToAddQuantity].quantity == 0) {
                orderInfo.splice(indexToAddQuantity, 1);
              }
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("AddToCartSuccess");
            });
        } else {
          if(orderInfo[indexToAddQuantity]) {
            if(orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.itemSearch[itemIndex].quantityNew = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              try {
                localStorage.removeItem(this.cartName);
                localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              } catch (e) {
                console.log(e);
              }
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if(orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(mainItem.id, itemIndex, category_id);
          this.showLoader();
          this.itemSearch[itemIndex].quantityNew = orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          try {
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          } catch (e) {
            console.log(e);
          }
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if(this.isLoadingGetItemDetail == false) {
            if(this.isOnline) {
              this.addCartAnimation(mainItem.id, itemIndex, category_id);
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 0,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.itemSearch[itemIndex].quantityNew = 1;
                    let orderInfo = JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(itemDetail.price_default);
                    itemDetail.member_price = parseFloat(itemDetail.member_price);

                    orderInfo.push(itemDetail);
                    localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.textLostInternet);
            }
          }
        }
      }
    },

    addCartAnimation(itemId, itemIndex, categoryId, groupId = 0, subGroupId = 0) {
      let prefixClass = categoryId;

      if (groupId) {
        prefixClass += '-' + groupId;
      }

      if (subGroupId) {
        prefixClass += '-' + subGroupId;
      }

      prefixClass += '-' + itemId;

      // Resolve the tapped item's image element + url, then fly it to the cart.
      const itemEl = document.querySelector('.item-img-' + prefixClass);
      if (!itemEl) return;
      const imgEl = itemEl.querySelector('img');
      const imageUrl = imgEl && imgEl.getAttribute('src');
      this.runFlyToCart(itemEl.getBoundingClientRect(), imageUrl);
    },
    // fly-to-cart triggered from the item-detail modal via the "FlyToCart"
    // EventBus payload (modal food-image rect + url). Direct card adds go
    // straight through addCartAnimation.
    onFlyToCart(payload) {
      if (!payload) return;
      this.runFlyToCart(payload.originRect, payload.imageUrl);
    },
    // Shared fly-to-cart tween (ported from advocado SF022): animate a single
    // element from originRect to the cart pill via requestAnimationFrame. Bails
    // on reduced-motion or a missing origin rect / image / pill.
    runFlyToCart(originRect, imageUrl) {
      const prefersReducedMotion =
        typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion) return;
      // Note: a missing/broken image is fine — flyStyle falls back to a tinted
      // tile, so only a missing origin rect or cart pill aborts the fly.
      if (!originRect) return;

      const pillEl = document.querySelector('.root_order_total');
      if (!pillEl) return;
      const targetRect = pillEl.getBoundingClientRect();

      // Cancel any in-flight tween so rapid taps restart cleanly.
      if (this.flyRafId != null) {
        cancelAnimationFrame(this.flyRafId);
        this.flyRafId = null;
      }

      // Floor against broken/collapsed origins (~0px) so the tile stays visible,
      // then cap the largest side so the fly launched from the modal's big hero
      // image doesn't start huge. Aspect ratio is preserved so it never distorts.
      const MAX_FLY_SIZE = 120;
      const rawW = Math.max(originRect.width, 48);
      const rawH = Math.max(originRect.height, 48);
      const capScale = Math.min(1, MAX_FLY_SIZE / Math.max(rawW, rawH));
      const startW = rawW * capScale;
      const startH = rawH * capScale;
      // Center the (possibly shrunk) tile on the origin's center so it launches
      // from where the user tapped rather than the image's top-left corner.
      const startX = originRect.left + originRect.width / 2 - startW / 2;
      const startY = originRect.top + originRect.height / 2 - startH / 2;
      // Aim for the pill's center; the element shrinks toward the end.
      const targetCenterX = targetRect.left + targetRect.width / 2;
      const targetCenterY = targetRect.top + targetRect.height / 2;

      const duration = 500;
      const start = performance.now();
      const easeInOutCubic = (t) =>
        t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

      const step = (now) => {
        const elapsed = now - start;
        const t = Math.min(1, elapsed / duration);
        const eased = easeInOutCubic(t);

        // Scale shrinks 1 → 0.2 so the element collapses into the pill; with
        // transform-origin center the visible center stays at the interpolated
        // (left + w/2, top + h/2), so interpolate the unscaled top-left.
        const scale = 1 + (0.2 - 1) * eased;
        const x = startX + ((targetCenterX - startW / 2) - startX) * eased;
        const y = startY + ((targetCenterY - startH / 2) - startY) * eased;
        const opacity = 1 + (0.6 - 1) * eased;

        this.flyState = { x, y, w: startW, h: startH, scale, opacity, imageUrl };

        if (t < 1) {
          this.flyRafId = requestAnimationFrame(step);
        } else {
          this.flyRafId = null;
          this.flyState = null;
        }
      };

      this.flyRafId = requestAnimationFrame(step);
    },

    showLoaderWithoutAnimation() {
      this.loaderActiveWithoutAnimation = true;
    },

    hideLoaderWithoutAnimation() {
      this.loaderActiveWithoutAnimation = false;
    },
    setTimeOutNotificationAsMember() {
      setTimeout(() => {
        this.snackbarAsMember = null;
      }, 10000);
    },
    closeSnackbarAsMember() {
        this.snackbarAsMember = null;
    },
    // MTH097: replaces the browser confirm() on the menu page. Stores the
    // removal as a pending action and opens the shared ModalConfirm; the user
    // answering No (or dismissing) simply leaves the action unrun.
    askRemoveItemConfirm(itemName, onConfirm) {
      this.txtConfirm =
        "Are you sure you want to remove this item '" + itemName + "' from your cart?";
      this.pendingConfirmAction = onConfirm;
      $(".btn-confirm-modal").click();
    },
    processConfirmYes() {
      // Dismiss explicitly — the Yes button carries no data-bs-dismiss, and a
      // modal left open on navigation strands its backdrop over the page.
      $(".btn-close-modal-confirm").click();
      const action = this.pendingConfirmAction;
      this.pendingConfirmAction = null;
      if (action) {
        action();
      }
    },
    handleNoThanksClicked() {
      // Close modal and proceed to my-cart
      let query = {};
      if (this.queue) {
        query.queue = this.queue;
      }
      this.gotoPath("MyCart", query);
    },
    handleUpsellItemsSelected(selectedItems) {
      console.log('Selected upsell items:', selectedItems);
      // Add selected upsell items to cart

      // Close modal and proceed to checkout
      let query = {};
      if (this.queue) {
        query.queue = this.queue;
      }
      this.gotoPath("MyCart", query);
    },

    // MTH013: show up to 2 upsell items as a promo banner above the menu list,
    // sourced from the same getUpsellItems feed the checkout upsell modal uses
    // (branch menuset -> minty_menuset_upsell_items). Each row is shaped
    // `{ item: {...} }`; unwrap to the menu item so image/price/id come from the
    // right place, drop image-less and $0 items, then cap at 2.
    async fetchUpsellBanners() {
      try {
        const res = await OrderService.getUpsellItems({
          set_id: this.branch.menuset_id
        });
        if (res?.data?.result?.isSuccess) {
          const items = Array.isArray(res.data.data?.upsell_items)
            ? res.data.data.upsell_items
            : [];
          this.upsellBanners = items
            .map((row) => (row && row.item ? row.item : row))
            .filter((item) => item && item.image)
            .filter((item) => {
              const price =
                parseFloat(item.price_default) || parseFloat(item.member_price) || 0;
              return price > 0;
            })
            .slice(0, 2)
            .map((item) => ({ ...item, file_url: item.image }));
          // MTH047: this feed resolves after getListCategory() already synced
          // the menu names, so translate the banner names too — otherwise a page
          // loaded in a non-English locale shows an English caption.
          this.syncMenuNames();
        } else {
          this.upsellBanners = [];
        }
      } catch (e) {
        this.upsellBanners = [];
      }
    },

    // MTH013: tapping a banner opens the item detail modal, matching how the
    // rest of the MOO menu handles an item tap (handles modifiers correctly).
    // Upsell items carry category_id = null; itemDetail resolves the item by
    // item_id and skips the category lookup when it is falsy.
    onUpsellBannerTap(banner) {
      if (!banner) return;
      this.gotoOrderDetail(
        banner.category_id,
        banner.id,
        banner.stock_balance,
        banner.is_not_available,
        banner.stock_enable_balance,
        banner
      );
    },

    checkShowUpsellItems(data) {
      if (data && data.is_enabled_upsell) {
        // call API getUpsellItems
        OrderService.getUpsellItems({
          set_id: this.branch.menuset_id
        }).then(response => {
          this.upsellItems = response.data.data.upsell_items;
          // Show Bootstrap modal
          $(".btn-show-upsell-items-modal").click();
        });
      }
    },

    gotoPath(name, query = {}) {
      this.$router.push({ name: name, params: {
        merchant_code: this.merchantCode,
        type: this.pathType,
        branch_code: this.branchCode,
        table_code: this.tableCode
      }, query: query });
    },
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        this.resizeLayout();
      }
    }
  }
};
</script>

<style scoped>
.order-info {
  height: 100%;
}

.i-search {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.i-search {
  background: var(--color);
  padding-bottom: 5px;
}

.category-info {
  /* overflow-y: auto; */
  padding-top: 10px;
}

.cat-layout {
  display: flex;
  align-items: flex-start;
}

.cat-layout__main {
  flex: 1;
  min-width: 0;
}

/* M1045: banner carries the header — top bar on top, search row at the bottom. */
.moo-hero {
  position: relative;
}

.moo-hero__band {
  height: 120px;
  background: var(--color);
}

.moo-hero__overlay {
  position: absolute;
  inset: 0;
  z-index: 25;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0.5rem 1rem 0.75rem;
  /* Let swipes in the middle of the banner reach the swiper. */
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.4) 0%,
    rgba(0, 0, 0, 0) 35%,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.35) 100%
  );
}

.moo-hero__overlay > * {
  pointer-events: auto;
}

/* Search row (design 6orderpage): full-width search + Table pill */
.moo-search-row {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
}

.moo-hero .moo-search__input,
.moo-hero .moo-table-pill {
  background: rgba(255, 255, 255, 0.92) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.moo-hero .moo-search__input {
  padding: 0.65rem 1rem 0.65rem 3rem;
}

.moo-hero .moo-table-pill {
  min-width: 60px;
  padding: 0.35rem 0.75rem;
}

/* M1045: slim sticky bar shown after the banner scrolls away. */
.moo-compact-anchor {
  position: sticky;
  top: 0;
  z-index: 30;
  height: 0;
}

.moo-compact {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  height: 60px;
  padding: 0 1rem;
  background: var(--theme-30, #ffffff);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  opacity: 0;
  transform: translateY(-100%);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.moo-compact.is-shown {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.moo-compact .moo-search__input {
  padding: 0.6rem 0.75rem 0.6rem 2.75rem;
}

.moo-compact .moo-search__icon {
  left: 0.85rem;
}

.moo-compact .moo-table-pill {
  align-self: stretch;
  min-width: 52px;
  margin: 8px 0;
  padding: 0 0.6rem;
}

.moo-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.moo-search__icon {
  position: absolute;
  left: 1rem;
  font-size: 22px;
  color: rgba(82, 67, 66, 0.6);
  pointer-events: none;
}

.moo-search__input {
  width: 100%;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: var(--theme-40, rgba(236, 224, 222, 0.4)) !important;
  background-image: none !important;
  border-radius: 1.25rem;
  padding: 1rem 1rem 1rem 3rem;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--moo-on-surface, #201a1a);
  -webkit-appearance: none;
  appearance: none;
}

.moo-search__input::placeholder {
  color: rgba(82, 67, 66, 0.6);
  font-weight: 500;
}

.moo-table-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  padding: 0.5rem 1rem;
  border-radius: 1.25rem;
  /* MTH073: --moo-surface-variant is never defined, so the pill always fell
     back to a fixed pink and ignored the merchant theme. Use the same token as
     .moo-search__input so the pill and the search field read as one row. */
  background: var(--theme-40, rgba(236, 224, 222, 0.4));
}

.moo-table-pill__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  text-transform: uppercase;
  color: var(--moo-secondary, #524342);
  margin-bottom: 0.25rem;
}

.moo-table-pill__no {
  font-size: 1.125rem;
  font-weight: 900;
  line-height: 1;
  color: var(--color, #201a1a);
}

/* ===== Design 6orderpage: section header + item cards ===== */
.cat-layout__main {
  padding-right: 1rem;
}

.tag-name-category {
  padding: 0.25rem 0.25rem 0.75rem;
}

.moo-cathead-row {
  width: 100%;
}

.moo-cathead-row > div:first-child {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 800;
  font-size: 1.15rem;
  letter-spacing: -0.02em;
  color: var(--moo-on-surface, #201a1a);
}

.moo-cat-count {
  flex-shrink: 0;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(82, 67, 66, 0.6);
}

/* Search results header + empty state (keeps the sidebar layout on search) */
.moo-search-head {
  padding: 0.25rem 0.25rem 0.75rem;
}

.moo-search-empty {
  padding: 1.5rem 0.5rem;
  text-align: center;
  font-size: 0.95rem;
  color: rgba(82, 67, 66, 0.6);
}

/* Item card */
.category-detail.list .item-tag {
  display: flex;
  gap: 0.75rem;
  position: relative;
  background: var(--theme-20, #ffffff);
  border: none !important;
  border-radius: 1.25rem;
  padding: 0.55rem;
  margin-bottom: 0.6rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  transition: transform 0.15s ease;
}

/* strip any inherited borders/dividers from the card content */
.category-detail.list .item-tag > div:first-child,
.category-detail.list .item-tag .item-info,
.category-detail.list .item-tag .item-info > div {
  border: none !important;
  box-shadow: none !important;
}

.category-detail.list .item-tag:active {
  transform: scale(0.98);
}

/* clickable wrapper = image + info row */
.category-detail.list .item-tag > div:first-child {
  display: flex;
  gap: 1rem;
  flex: 1;
  min-width: 0;
}

.category-detail.list .item-tag .item-img {
  width: 74px;
  height: 74px;
  flex-shrink: 0;
}

.category-detail.list .item-tag .item-img img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: 1rem !important;
}

.category-detail.list .item-tag .item-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  margin-left: 0 !important;
  padding: 0.15rem 0;
}

/* item name */
.category-detail.list .item-tag .item-info > div:first-child {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  line-height: 1.2 !important;
  color: var(--moo-on-surface, #201a1a);
  margin-top: 0 !important;
}

/* item description */
.category-detail.list .item-tag .item-info > div:nth-child(2) {
  font-size: 0.7rem;
  line-height: 1.4;
  color: var(--moo-secondary, #524342);
  margin-top: 0.15rem !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* price */
.category-detail.list .item-tag .price-defalut,
.category-detail.list .item-tag .price-defalut.active {
  font-weight: 700 !important;
  font-size: 0.82rem !important;
  color: var(--color) !important;
}

/* round add / quantity button, filled with the theme colour */
.category-detail.list .item-tag .change-item-qty > div {
  background: var(--color) !important;
  border-color: var(--color) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  /* sit 5px in from the card's bottom-right edge (overrides inline right/bottom) */
  right: 5px !important;
  bottom: 5px !important;
}

.category-detail.list .item-tag .change-item-qty > div span {
  color: var(--moo-on-primary, #ffffff) !important;
}

.category-list,
.group-list {
  display: flex;
  width: 100%;
  overflow-x: auto;
}

.category-list {
  padding-bottom: 5px;
  background: var(--moo-surface, #ffffff);
}

.category-list.list {
  position: absolute;
  left: 0;
  width: 85px !important;
  flex-direction: column;
  padding: 0;
  overflow-y: auto;
  border-right: 3px solid var(--color);
  padding-bottom: calc((100vh - 407px) / 2);
}

.category-list.fixed {
  position: fixed;
  top: 0;
  z-index: 9;
}

.group-and-type-list {
  margin: 0 24px;
}

.category-detail.list,
.group-list.list,
.group-and-type-list.list {
  margin-left: 20px !important;
  padding-left: 0 !important;
}

.category-description {
  font-weight: normal;
  font-size: 11px;
}

.category-list .category-tag {
  /* width: 100px;
  min-width: 100px; */
  width: fit-content;
  min-width: fit-content;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 15px;
  cursor: pointer;
  border-bottom: 1px solid lightgray;
}

.category-list.list .category-tag {
  width: 75px;
  min-width: 75px;
  margin-right: 0 !important;
}

.category-list.list .category-tag:last-child,
.category-detail.list .item-list:last-child {
  margin-bottom: 20px;
}

.category-list.list .category-tag {
  margin-top: 10px;
  
}

.category-list .category-tag {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.category-list .category-tag.active {
  color: var(--color) !important;
  border-color: var(--color) !important;
}

.category-list .category-tag.active img {
  border: 2px solid var(--moo-active-ring, #25ccf7);
}

.category-list .category-tag img {
  width: 45px;
  height: 45px;
  border-radius: 10px;
}

.category-list .category-tag > div:last-child {
  font-size: 15px;
  line-height: 15px;
}

.group-list .group-tag {
  font-size: 13px;
  font-weight: bold;
  padding: 5px 25px;
  background: var(--moo-outline, #f1f1f1);
  border-radius: 20px;
  white-space: pre;
  cursor: pointer;
}

.group-list .group-tag.active {
  background: var(--color);
}

.group-list .group-tag:not(:last-child) {
  margin-right: 15px;
}

.category-list::-webkit-scrollbar,
.group-list::-webkit-scrollbar {
  display: none;
}

.item-list .tag-name {
  font-size: 18px;
  font-weight: bold;
}

.item-list .tag-name-category {
  font-size: 18px;
  font-weight: bold !important;
}

.item-list .tag-name-group {
  font-size: 16px;
  font-weight: bold;
}

.item-list .tag-name-sub-group {
  font-size: 14px;
  font-weight: bold;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
  background-color: var(--moo-surface, #ffffff) !important;
  border-radius: 50px;
  text-align: left !important;
}

input[type="search"]::placeholder {
  color: var(--moo-placeholder, #bbb);
  text-align: left;
  font-weight: normal;
  font-size: 13px;
}

input[type="search"]:focus {
  outline: none;
  border: none;
}

input.nosubmit {
  width: 100%;
  height: 32px;
  padding: 5px 4px 5px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.banner {
  position: relative;
}

.item-list > div:first-child {
  padding: 5px 0;
  border-bottom: 0.5px solid var(--moo-outline, #f1f1f1);
}

.item-list .grid .row > div > div {
  border: 1px solid var(--moo-outline, #f1f1f1);
  border-radius: 15px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  padding: 10px;
}

.item-list .grid .row > div > div:not(.item-not-available) {
  padding-bottom: 45px !important;
}

.item-list .list > div > div {
  display: flex;
  width: 100%;
  padding: 7px 0;
  border-bottom: 2px solid var(--moo-outline, #f1f1f1);
  font-size: 11px;
}

.item-list .list > div:last-child > div {
  border-bottom: none;
}

.item-list .list > div.active {
  background-color: var(--moo-active-bg, #fff6e4);
}

.item-list > div:first-child {
  margin: 0 24px;
}

.category-detail.list .item-list > div:first-child,
.type-list.list {
  margin: 0 0 0 0;
}

.item-list .list > div .item-info div:first-child,
.item-list .list > div .item-info div:last-child,
.item-list .grid .item-info > div {
  font-size: 17px;
  word-break: break-word;
}

.item-list .list > div .item-info > div:first-child {
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.material-icons-round.active {
  color: var(--color);
}

.item-tag {
  display: flex;
}

.row-flex {
  display: flex;
  flex-wrap: wrap;
}

.row-flex > [class*="col-"] {
  margin-bottom: 15px;
}

.txt_popular {
  height: 100%;width: fit-content;background: var(--color);padding-left: 7px;padding-right: 7px;border-radius: 10px;margin-top: 2px; font-size: 11px !important;font-weight: normal !important;
}

.txt_popular_grid {
  height: 100%;width: fit-content;background: var(--color);padding-left: 7px;padding-right: 7px;border-radius: 10px;margin-top: 2px;font-size:11px !important;font-weight: normal !important;
}

.member-price{
  color: var(--color) !important;
}

.from-label {
  font-size: 11px !important;
  font-style: italic;
  color: var(--color) !important;
}
/* KSK119: the usual price, struck through before a scheduled one. */
.schedule-struck {
  margin-right: 6px;
  font-size: 11px !important;
  font-weight: 500 !important;
  color: var(--moo-muted, #9e9e9e) !important;
  text-decoration: line-through;
}

.price-defalut,
.member-price .price,
.grid .member-price .price {
  font-size: 13.5px !important;
}

.price-defalut.active,
.member-price.active {
  text-decoration: none;
}
.wrap-category {
  position: relative;
}
.wrap-category > .custom-star {
  position: absolute;
  height: 20px !important;
  width: 20px !important;
  right: 0px;
  top: -5px;
}
.category-list .category-tag.active .custom-star {
  display: none !important;
}
.container-custom {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-width: 480px;
    margin: 0 auto;
}

.content-custom {
    flex: 1;
    background-color: var(--theme-30, white);
    overflow-x: auto;
    scrollbar-width: none; /* Firefox */
}

.content-custom::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Edge */
}
footer {
  background-color: var(--theme-30, white);
  padding-top: 10px;
}
.addOverFlow {
  overflow-y: auto
}
.removeOverFlow {
  overflow-y: auto
}
.selectedItem {
  /* border-left: 2px solid var(--color); */
  /* padding-left: 5px; */
}
/* webkit solution */
::-webkit-input-placeholder {
  text-align:left !important;
}
/* mozilla solution */
input:-moz-placeholder {
  text-align:left !important;
}
.fs-11 {
  font-size: 11px !important;
}
.change-item-qty {
  width: auto !important;
}
.add-more-item {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
  width: auto !important;
}
.item-not-available {
  opacity: 0.5 !important;
}

@media only screen and (max-width: 370px) {
  .item-list .list .item-tag .item-info {
    padding-bottom: 30px;
  }
}
</style>
